import WechatOpenAppDialog from '@/components/wechat/open-app-dialog.vue'
import { callKBApp } from '@/hooks/use-call-kbapp'
import { runAction } from '@/utils/action'
import { isKbApp, isWechat } from '@/hooks/use-env'
import { defineVComponent, destroyVComponent, renderVComponent } from '@/utils/vue-root-render'

/**
 *
 * @description 安卓下,需要尝试唤起特殊的引导app中打开的弹窗
 */
export function openWechatRedirectKbAppDialog(extInfo: { action?: any, actionParams?: any }) {
    const target = defineVComponent(WechatOpenAppDialog, {
        props: { extInfo },
    })

    target.$on('close', () => {
        setTimeout(() => {
            destroyVComponent(target)
        }, 600)
    })

    renderVComponent(target, 'body')
}

/**
 *
 * @description 适配微信特殊情况的runAction
 */
export function callKBAppAdaptWechat (extInfo: { action: any, actionParams?: any }) {
    if (isKbApp) {
        return runAction(extInfo)
    }

    if (/(Android)/i.test(navigator.userAgent) && isWechat) {
        openWechatRedirectKbAppDialog(extInfo)
    } else {
        callKBApp(extInfo)
    }
}